
import { mapActions, mapState, mapGetters } from "vuex";
import dialogCloseBtn from "../common/dialog-close-btn.vue";
import ResponsiveDialog from "./responsive-dialog.vue";
import WatchVideo from "../common/watch-video.vue";

export default {
  components: { dialogCloseBtn, ResponsiveDialog, WatchVideo },
  data() {
    return {
      newChannel: {
        name: "",
        platform_url: "",
        login_id: "",
        restaurant_id: ""
      }
    };
  },
  props: {
    dialog: false,
    loading: false,
    selectedChannel: {},
    selectedBrandId: {
      type: Number,
      default: ""
    },
    isUnpairForChannel: {
      type: Boolean,
      default: false
    },
    channelsList: {
      type: Array,
      default: []
    }
  },

  mounted() {
    // Check if there is user input is present. If yes, populate the fields
    const existingInput = this.getExistingData();
    if (existingInput) {
      this.newChannel = { ...existingInput };
    } else {
      this.newChannel = { ...this.selectedChannel };
      this.newChannel.restaurant_id = this.selectedBrandId;
      this.newChannel.name = this.selectedChannel.name;
    }
  },
  methods: {
    getExistingData() {
      let matchingRestaurant = this.channelsList.find(
        (item) => item.id === this.selectedBrandId
      );
      let matchingChannel = matchingRestaurant.restaurant_platforms.find(
        (item) => item.id === this.selectedChannel.id
      );
      return matchingChannel.userInput;
    },
    handleFormSubmit() {
      if (this.isUnpairForChannel) {
        this.$emit("show-unpair-channel-confirmation", this.newChannel);
      } else {
        this.$emit("submit-channel-for-pairing", this.newChannel);
      }
    }
  }
};
